// extracted by mini-css-extract-plugin
module.exports = {"container":"Login_container_3_t-H","header":"Login_header_2uBAF","form":"Login_form_2UoYY","registration":"Login_registration__doof"};